import React, { useMemo, useState, useEffect  } from "react";
import { useTable, useSortBy, useGlobalFilter} from "react-table";
import "./TableKarty.css";
import GlobalFilter from "./GlobalFilterKarty"
import { authHeader } from '../_helpers';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { RiDeleteBin2Fill } from "react-icons/ri";
import { FaInfoCircle } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import { Link } from 'react-router-dom';
import zIndex from "@mui/material/styles/zIndex";
import { MdOutlineRefresh } from "react-icons/md";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/cs';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 480,
  bgcolor: '#EEEDEB',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  zIndex: 1,

};

const divStyle = {
  color: 'blue',
  backgroundColor: 'red',
};

const TableKarty= () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([]);
  const [delid,setDelid]=useState();
  const [delpar,setDelpar]=useState();
  const [deljmeno,setDeljmeno]=useState();
  const from = 'aabbcc';
  const [typoptions,setTypoptions]=useState();
  const [typvalues,setTypvalues]=useState([]);
  const [skupoptions,setSkupoptions]=useState();
  const [skupvalues,setSkupvalues]=useState([]);
  const [funkoptions,setFunkoptions]=useState();
  const [funkvalues,setFunkvalues]=useState([]);
  const [datumOd, setDatumOd] = useState(dayjs()); // Výchozí hodnota
  const [datumDo, setDatumDo] = useState(dayjs()); 
  const [cleared, setCleared] = useState(false);

  
  const [ID, setID] = useState();

  const [params, setParams] = useState({
    ztyp: ''
  });

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [open3, setOpen3] = React.useState(false);
 
  const user = JSON.parse(localStorage.getItem('user'));
 

  const [klic, setKlic] = useState({
          klic_fi: '',
          klic_ID: '',
          klic_cislo: '',
          klic_popis: '',
          klic_skup: '',
          klic_typ: '',
          klic_stav: '',
          klic_OD: '',
          klic_DO: '' 
  });

  const columns = useMemo(
    () => [
      { Header: "ID klíče", accessor: "klic_id" },
      { Header: "Název", accessor: "klic_popis" },
      { Header: "Číslo klíče", accessor: "klic_cislo" },
      { Header: "Skupina", accessor: "skup" },
      { Header: "Funkce", accessor: "typ" },
      { Header: "Platnost klíče", accessor: "platnost" },
      { Header: "Vytvořeno", accessor: "ins" },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter
  } = useTable({ columns, data }, useGlobalFilter, useSortBy);

  const { globalFilter} = state

  const handleFormSubmit = (event) => {
    event.preventDefault();
    
    //if (typeof(options) !== 'undefined' && options != null && options != "default") {
      //params.ztyp = options;
      fetchData();
    //} else {
      //alert("Zvolte typ zařízení!");
    //}
  }

  const handleTypSelectChange = (event) => {
          setTypoptions(event.target.value);
      }
  
      const fetchDropDownTyp = () => {
          
              //const firma = JSON.parse(localStorage.getItem('firma'));         
  
              const requestOptions = {
                  method: 'GET',
                  headers: authHeader()
              };
              fetch(process.env.REACT_APP_API_URL+"/api/private/skupiny/"+user.u_fi+"/all", requestOptions).then((data)=>data.json()).then((val)=>setTypvalues(val)) 
          
      }

      const fetchDropDownSkup = () => {
        const firma = JSON.parse(localStorage.getItem('firma'));
        const requestOptions = {
          method: 'GET',
          headers: authHeader()
        };
        fetch(`${process.env.REACT_APP_API_URL}/api/private/skupiny/${firma[0].fi_ID}/all`, requestOptions)
          .then((data) => data.json())
          .then((val) => setSkupvalues(val));
      };

      const fetchDropDownFunk = () => {
        const firma = JSON.parse(localStorage.getItem('firma'));
        const requestOptions = {
          method: 'GET',
          headers: authHeader()
        };
        fetch(`${process.env.REACT_APP_API_URL}/api/private/allkltyp/${firma[0].fi_ID}`, requestOptions)
          .then((data) => data.json())
          .then((val) => setFunkvalues(val));
      };
      
         

  const handleInputChange = (event) => {
    
    setID(event.target.value);
    
  };

  const fetchData = async () => {
    var skup;
    if (typoptions == "default" || typeof(typoptions) == 'undefined') {
      skup='all';   
    } else {
      skup=typoptions;
    } 

    setLoading(true);
    try {
      const firma = JSON.parse(localStorage.getItem('firma'));
      const requestOptions = {
        method: 'GET',
        headers: authHeader()
      };
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/private/allklice/${firma[0].fi_ID}/${skup}`, requestOptions);
      const apidata = await response.json();
      setData(apidata);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };

  const handleEditRow = (klic_ID, klic_popis, klic_cislo, skup, klic_typ, platnost) => {
  if (!platnost) return;

  // Rozdělení na datum OD a DO a odstranění přebytečných mezer
  const platnostParts = platnost.split(" - ").map(part => part.trim());
  if (platnostParts.length !== 2) return;

  const datumOd = dayjs(platnostParts[0].split(" ")[0], "DD.MM.YYYY", true);
  const datumDo = dayjs(platnostParts[1].split(" ")[0], "DD.MM.YYYY", true);

  // Nastavení hodnot, pokud jsou validní
  setDatumOd(datumOd.isValid() ? datumOd : dayjs());
  setDatumDo(datumDo.isValid() ? datumDo : dayjs());

  setKlic({
    klic_fi: JSON.parse(localStorage.getItem('firma'))[0].fi_ID,
    klic_ID,
    klic_cislo,
    klic_popis,
    klic_skup: skup,
    klic_typ,
    klic_stav: 2,
    klic_OD: datumOd.format("YYYY-MM-DD"),
    klic_DO: datumDo.format("YYYY-MM-DD"),
  });

  fetchDropDownSkup();
  fetchDropDownFunk();
  setOpen3(true);
  };



  
  
  

  function editWrapper() {
    klic.klic_OD = new Date(datumOd).toLocaleDateString('zh-Hans-CN') + " 00:00";
    klic.klic_DO = new Date(datumDo).toLocaleDateString('zh-Hans-CN') + " 23:59";   
    
    // Najít odpovídající cis_id na základě názvu skupiny
    const selectedGroup = skupvalues.find((opts) => opts.s_name === klic.klic_skup);
    const groupId = selectedGroup ? selectedGroup.s_id : null;
    klic.klic_skup=groupId;

    const selectedFunkce = funkvalues.find((opts) => opts.cis_pop === klic.klic_typ);
    const funkceId = selectedFunkce ? selectedFunkce.cis_id : null;
    klic.klic_typ=funkceId;
    //console.log(klic);

    if (klic.klic_popis == '') {
      alert("Název klíče nemůže být prázdný!");
    } else if (klic.klic_skup==null) {
      alert("Zvolte skupinu klíče");
    } else if (klic.klic_typ==null) {
      alert("Zvolte funkci klíče");
    } else if (typeof(datumOd) == 'undefined' || datumOd == null || typeof(datumDo) == 'undefined' || datumDo == null || klic.klic_OD == 'Invalid Date' || klic.klic_DO == 'Invalid Date') {
      alert("Zvolte platné datum!");      
        
    } else {

    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/api/private/newklic`, {
      method: 'POST',
      headers: { ...authHeader(), 'Content-Type': 'application/json' },
      body: JSON.stringify(klic)
    }).then(() => {
      fetchData();
      setLoading(false);
      setOpen3(false);
    });
    }
  }

  const handleDeleteRow = (klic_ID, klic_popis) => {
    setKlic({
      klic_fi: JSON.parse(localStorage.getItem('firma'))[0].fi_ID,
      klic_ID,
      klic_cislo: '',
      klic_popis,
      klic_skup: '',
      klic_typ: '',
      klic_stav: 9,
      klic_OD: '',
      klic_DO: ''
    });
    setOpen(true);
  };

  const deleteWrapper = () => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}/api/private/newklic`, {
      method: 'POST',
      headers: { ...authHeader(), 'Content-Type': 'application/json' },
      body: JSON.stringify(klic)
    }).then(() => {
      fetchData();
      setLoading(false);
      setOpen(false);
    });
  };

  const fetchDeletePost = () => {
      console.log(`Mažu: ${JSON.stringify(klic)}`);
      setKlic({ klic_fi: '', klic_ID: '', klic_cislo: '', klic_popis: '', klic_skup: '', klic_typ: '', klic_stav: '', klic_OD: '', klic_DO: ''});
      
      return fetch(`${process.env.REACT_APP_API_URL}/api/private/newklic`, {
          method: 'POST',
          headers: { ...authHeader(), 'Content-Type': 'application/json' },
          body: JSON.stringify(klic)
      }).then(handleResponse);
  };

  function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (response.status === 200) {
            console.log("POSTED")
        } else {console.log("ERR"); alert("Špatně zvolené jméno nebo heslo, zkuste znovu.");}
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                //logout();
                //location.reload(true);
            }
            if (response.status === 200) {
                console.log("POSTED")
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
  }

  function handleRefresh() {
    
    fetchData();
    
  }
  
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
  if (klic.klic_OD) {
    setDatumOd(new Date(klic.klic_OD));
  }
  if (klic.klic_DO) {
    setDatumDo(new Date(klic.klic_DO));
  }
  }, [klic.klic_OD, klic.klic_DO]);

  
  return (
    <>
      
      <div className="containerInputs">
        
      
      <Modal open={open} onClose={() => setOpen(false)}>
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <div className="modalheaderDelKl">
                <h3>Opravdu smazat klíč?</h3>
              </div>
              <div className="modalbodyDelKl">
              <p>Název: <b>{klic.klic_popis}</b><br />ID: <b>{klic.klic_ID}</b></p>
              </div>
            </Typography>
            <button className="btnDelPotvrd" onClick={deleteWrapper}>Potvrdit</button>
            <button className="btnDelZrus" onClick={() => setOpen(false)}>Zrušit</button>
          </Box>
        </Modal>

        <Modal open={open3} onClose={() => setOpen3(false)}>
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <div className="modalheaderEditKl">
                <h3>Editace klíče</h3>
              </div>
              <div className="modalbodyEditKl">
                <label className="lblEditUziv">
                  <input
                    type="text"
                    name="klic_popis"
                    value={klic.klic_popis}
                    onChange={(e) => setKlic({ ...klic, klic_popis: e.target.value })}
                    className="inputEditUziv"
                    required="required"
                    placeholder=" "
                  />
                  <span>Název klíče</span>
                </label>
                <label className="lblEditUziv">
                  <input
                    type="text"
                    name="klic_cislo"
                    value={klic.klic_cislo}
                    onChange={(e) => setKlic({ ...klic, klic_cislo: e.target.value })}
                    className="inputEditUziv"
                    required="required"
                    placeholder=" "
                  />
                  <span>Číslo klíče</span>
                </label>
                <label className="lblParSkup" htmlFor="inputParSkup">Skupina:</label>
                <select
                  className="inputParSkup"
                  value={klic.klic_skup || "default"}
                  onChange={(e) => setKlic({ ...klic, klic_skup: e.target.value })}
                >
                  <option value="default">Vyber skupinu...</option>
                  {skupvalues.map((opts) => (
                    <option key={opts.s_id} value={opts.s_name}>{opts.s_name}</option>
                  ))}
                </select>

                <label className="lblParSkup" htmlFor="inputParSkup">Funkce:</label>
                <select
                  className="inputParSkup"
                  value={klic.klic_typ || "default"}
                  onChange={(e) => setKlic({ ...klic, klic_typ: e.target.value })}
                >
                  <option value="default">Vyber funkci...</option>
                  {funkvalues.map((opts) => (
                    <option key={opts.cis_id} value={opts.cis_pop}>{opts.cis_pop}</option>
                  ))}
                </select>

                <section className='platnost'>
                                        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="cs">
                
                                        <DatePicker
                                          className="platnostOD"
                                          name="klic_OD"
                                          label="Platnost OD"
                                          value={dayjs(datumOd)}
                                          maxDate={dayjs(datumDo)}
                                          onChange={(newValue) => setDatumOd(dayjs(newValue))}
                                          required="required"
                                          format="DD/MM/YYYY"
                                        />

                                        <DatePicker
                                          className="platnostDO"
                                          name="klic_DO"
                                          label="Platnost DO"
                                          value={dayjs(datumDo)}
                                          minDate={dayjs(datumOd)}
                                          onChange={(newValue) => setDatumDo(dayjs(newValue))}
                                          required="required"
                                          format="DD/MM/YYYY"
                                        />



                
                                        </LocalizationProvider>
                </section>   
            </div>                                
            </Typography>
            <button className="btnDelPotvrd" onClick={editWrapper}>Potvrdit</button>
            <button className="btnDelZrus" onClick={() => setOpen3(false)}>Zrušit</button>
          </Box>
        </Modal>
         
      <form className="formInputs" onSubmit={handleFormSubmit} >
            
                  
      </form>
      
      <div className="contHledej">
      <GlobalFilter  filter={globalFilter} setFilter={setGlobalFilter} />
      <select className='selectSkup' onChange={handleTypSelectChange} onClick={fetchDropDownTyp}>
                        <option value="default">Skupina. . .  (vše)</option>
                        {
                            typvalues.map((opts,i)=><option key={i}>{opts.s_name}</option>)
                        }
      </select>            
      <button className="btnRefresh" onClick={handleRefresh}><MdOutlineRefresh /></button>
        
        
      </div>
      <div className="btnNewZarizeni"><Link to={"/karty_new"}><button className="btnNewZarizeni_style"> + Nový</button></Link></div>
      
      </div>
      
    <div className="container">
        
        {
        loading ?  
        <div id="tablespinner" className="spinner-border"></div>
        :
        <div className="table_wrapper">    
        <table className="tableZarizeni" {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render("Header")}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? " 🔽"
                          : " 🔼"
                        : ""}
                    </span>
                  </th>
                ))}
                <th className="thoperace"></th>
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  ))}
                  <td>
                    <div className="rowBtns">
                      <a className="btnEditKar" onClick={() => handleEditRow(row.original.klic_id,  row.original.klic_popis, row.original.klic_cislo, row.original.skup, row.original.typ, row.original.platnost)}><FaEdit /></a>
                      <a className="btnDelKar" onClick={() => handleDeleteRow(row.original.klic_id, row.original.klic_popis)}><RiDeleteBin2Fill /></a>
                      
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        </div>
        }
    </div>
    </>
  );
  
};

export default TableKarty;
